if (!customElements.get("cart-drawer-info-slider")) {
  class a extends HTMLElement {
    constructor() {
      super(), Shopify.designMode && window.addEventListener("shopify:section:load", e => {
        this.init()
      }), this.init()
    }
    init() {
      var e = document.querySelector(".cart-drawer__swiper");
      this.slider = new Swiper(e, {
        direction: "vertical",
        slidesPerView: 1,
        loop: !0,
        allowTouchMove: !1,
        autoplay: {
          delay: 5e3
        }
      })
    }
  }
  customElements.define("cart-drawer-info-slider", a)
}